import { MarvinConfig, getDefaultServices } from '@Constants/MarvinConstants';
import MessageBroker from '@Services/MessageBroker';

const ServiceName = 'MarvinDataConverter';

export const error = (msg) => {
  Logger.error(msg);
  return Promise.reject();
};

export const convert = (structure, inputFormat = MarvinConfig.exportFormat, parameters = '') => {
  const data = { structure, inputFormat, parameters }; // Request params
  if (!structure || !inputFormat || !parameters) {
    return error(`${ServiceName}: Missing some required params.`);
  }
  const services = getDefaultServices();
  return MessageBroker.send({ method: 'POST', url: services.molconvertws }, data, {
    ignoreAllSpecificHeaders: true,
    withCredentials: false,
  })
    .then((responseData) => {
      return !responseData || !responseData.structure ? Promise.reject() : responseData;
    })
    .catch(() => error(`${ServiceName}: Can't convert '${inputFormat}' => '${parameters}'. Structure: ${structure}`));
};
